var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.083 14a1 1 0 0 1 1 1c0 1.703-.24 3.047-.734 4.09-.507 1.071-1.26 1.776-2.17 2.212-.877.422-1.86.572-2.807.635-.928.061-1.98.043-2.906.063H10.7c-.927-.02-1.978-.002-2.906-.063-.948-.063-1.93-.213-2.808-.635-.91-.436-1.662-1.14-2.17-2.212-.493-1.043-.733-2.387-.733-4.09a1 1 0 1 1 2 0c0 1.539.22 2.557.54 3.234.308.648.723 1.022 1.228 1.265.538.257 1.22.385 2.075.442.874.058 1.767.037 2.817.059h2.68c1.05-.023 1.942-.001 2.817-.059.855-.057 1.537-.185 2.074-.442.505-.243.92-.617 1.228-1.265.32-.678.54-1.695.54-3.234a1 1 0 0 1 1-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.083 2a1 1 0 0 1 1 1v10.586l2.793-2.793a1 1 0 0 1 1.414 1.414l-4.5 4.5a1 1 0 0 1-1.414 0l-4.5-4.5a1 1 0 1 1 1.414-1.414l2.793 2.793V3a1 1 0 0 1 1-1"
  })));
};
export default Svg24;